// router.js
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  RouterProvider,
  defer,
} from "react-router-dom";

import { useAuth } from "./components/auth/AuthProvider";

import HomeLayout from "./components/layouts/HomeLayout";
import AuthLayout from "./components/auth/AuthLayout";
import { AuthLayer } from "./components/auth/AuthLayer";

import Login from "./components/Login/Login";
import Main from "./components/main/Main";
import AddSKUs from "./components/main/addSKUs/AddSKUs";
import AddBuyingOrder from "./components/main/addBuyingOrder/AddBuyingOrder";
import VerifySKUs from "./components/main/verifySKUs/verifySKUs";
import ReviewPO from "./components/main/reviewPO/ReviewPO";
import PORecords from "./components/main/poRecords/poRecords";
import Reconcillation from "./components/main/reconcillation/reconcillation";
import VendorPage from "./components/main/vendorPage/VendorPage";
import Success from "./components/validate/Success";

const getUserData = () =>
  new Promise((resolve) =>
    setTimeout(() => {
      const user = window.localStorage.getItem("login-token");
      resolve(user);
    }, 1000)
  );

function RedirectToCorrectPage() {
  const { userToken } = useAuth();
  return userToken ? <Navigate to="/admin" /> : <Navigate to="/admin/login" />;
}

export function AppRouter() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route element={<HomeLayout />}>
          <Route path="/" element={<RedirectToCorrectPage />} />

          <Route path="/success" element={<Success />} />

          <Route
            path="/review-vendor/:validateToken"
            element={<VendorPage />}
          />
          <Route
            path="/update-vendor/:validateToken"
            element={<VendorPage />}
          />
          <Route
            path="/review-skus/:validateToken"
            element={<VerifySKUs />}
          />
          <Route
            path="/review-po/:validateToken"
            element={<ReviewPO />}
          />

          {/* ADMIN AREA */}
          <Route
            path="/admin"
            element={<AuthLayer />}
            loader={() => defer({ userPromise: getUserData() })}
          >
            <Route element={<AuthLayout />}>
              <Route path="login" element={<Login />} />

              <Route index element={<Main />} />

              <Route path="vendor-registration" element={<VendorPage />} />

              <Route path="po-records" element={<PORecords />} />
              <Route path="po-records/:poCode" element={<Reconcillation />} />

              <Route path="new-skus/:vendorCode" element={<AddSKUs />} />

              <Route
                path="new-buying-order/:vendorCode"
                element={<AddBuyingOrder />}
              />

              <Route
                path="vendor/:vendorCode"
                element={<VendorPage />}
              />
            </Route>
          </Route>
        </Route>
      </>
    )
  );

  return <RouterProvider router={router} />;
}
